// Generated by purs version 0.15.15
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Ouroboros_Models_Brands_Email from "../Ouroboros.Models.Brands.Email/index.js";
import * as Ouroboros_Models_Brands_ErrorMessageText from "../Ouroboros.Models.Brands.ErrorMessageText/index.js";
import * as Ouroboros_Models_Brands_Password from "../Ouroboros.Models.Brands.Password/index.js";
import * as Ouroboros_Models_Brands_PasswordResetToken from "../Ouroboros.Models.Brands.PasswordResetToken/index.js";
import * as Ouroboros_Models_Core_ErrorHandlers from "../Ouroboros.Models.Core.ErrorHandlers/index.js";
import * as Ouroboros_Models_Core_Ok from "../Ouroboros.Models.Core.Ok/index.js";
import * as Ouroboros_Programs_Capabilities from "../Ouroboros.Programs.Capabilities/index.js";
import * as Ouroboros_Services_Clients_Interop_IO from "../Ouroboros.Services.Clients.Interop.IO/index.js";
import * as Ouroboros_Services_Clients_Interop_Option from "../Ouroboros.Services.Clients.Interop.Option/index.js";
import * as Ouroboros_Services_Clients_Interop_Task from "../Ouroboros.Services.Clients.Interop.Task/index.js";
import * as Ouroboros_Services_Clients_Interop_TaskEither from "../Ouroboros.Services.Clients.Interop.TaskEither/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(Ouroboros_Models_Brands_Email.eqEmail);
var withPasswordSubmitting = function (kernel) {
    return function (task) {
        var setSubmitting = function (value) {
            return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(kernel.passwordSubmitting))(value);
        };
        return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
            return Ouroboros_Services_Clients_Interop_Task.chain(function (v1) {
                return Ouroboros_Services_Clients_Interop_Task.fromIO(setSubmitting(false));
            })(task);
        })(Ouroboros_Services_Clients_Interop_Task.fromIO(setSubmitting(true)));
    };
};
var toPasswordResetErrorInput = function (errorValue) {
    var statusCode = (function () {
        if (errorValue.statusCode instanceof Data_Maybe.Nothing) {
            return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
        };
        if (errorValue.statusCode instanceof Data_Maybe.Just) {
            return Ouroboros_Services_Clients_Interop_Option.some(errorValue.statusCode.value0);
        };
        throw new Error("Failed pattern match at Ouroboros.Programs.Controllers.AccountManagement (line 222, column 7 - line 224, column 40): " + [ errorValue.statusCode.constructor.name ]);
    })();
    var message = Ouroboros_Models_Core_ErrorHandlers.passwordResetErrorMessage({
        type: errorValue.type,
        message: errorValue.message,
        statusCode: statusCode
    });
    return {
        message: message.message,
        info: message.info
    };
};
var toAccountErrorInput = function (errorValue) {
    var statusCode = (function () {
        if (errorValue.statusCode instanceof Data_Maybe.Nothing) {
            return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
        };
        if (errorValue.statusCode instanceof Data_Maybe.Just) {
            return Ouroboros_Services_Clients_Interop_Option.some(errorValue.statusCode.value0);
        };
        throw new Error("Failed pattern match at Ouroboros.Programs.Controllers.AccountManagement (line 204, column 7 - line 206, column 40): " + [ errorValue.statusCode.constructor.name ]);
    })();
    var message = Ouroboros_Models_Core_ErrorHandlers.accountErrorMessage({
        type: errorValue.type,
        message: errorValue.message,
        statusCode: statusCode
    });
    return {
        message: message.message,
        info: message.info
    };
};
var runPasswordResetRequest = function (v) {
    return function (request) {
        return v(request);
    };
};
var runPasswordResetComplete = function (v) {
    return function (request) {
        return v(request);
    };
};
var runLoadingAction = function (v) {
    return v;
};
var readOption = function (v) {
    return v;
};
var passwordMismatchError = {
    message: /* #__PURE__ */ Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Passwords do not match."),
    info: /* #__PURE__ */ Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)
};
var missingResetTokenError = {
    message: /* #__PURE__ */ Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Verification code is required."),
    info: /* #__PURE__ */ Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)
};
var missingPasswordError = {
    message: /* #__PURE__ */ Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Enter and confirm your new password."),
    info: /* #__PURE__ */ Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)
};
var missingAccountDetailsError = {
    message: /* #__PURE__ */ Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Account details unavailable."),
    info: /* #__PURE__ */ Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)
};
var matchesAccount = function (response) {
    return function (user) {
        return eq(user.email)(response.email);
    };
};
var updateMembership = function (kernel) {
    return function (response) {
        return function (usersResponse) {
            var v = Data_Array.find(matchesAccount(response))(usersResponse.items);
            if (v instanceof Data_Maybe.Nothing) {
                return Ouroboros_Services_Clients_Interop_IO.pure(Ouroboros_Models_Core_Ok.ok);
            };
            if (v instanceof Data_Maybe.Just) {
                return Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetSome(kernel.membership))({
                    role: v.value0.role,
                    status: v.value0.status
                });
            };
            throw new Error("Failed pattern match at Ouroboros.Programs.Controllers.AccountManagement (line 92, column 3 - line 98, column 10): " + [ v.constructor.name ]);
        };
    };
};
var handlePasswordResetRequestSuccess = function (kernel) {
    return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(kernel.passwordStep))("complete"));
    })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(kernel.loading.setSuccess)));
};
var handlePasswordResetError = function (kernel) {
    return function (errorValue) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(kernel.loading.setError(toPasswordResetErrorInput(errorValue))));
    };
};
var requestPasswordResetTask = function (kernel) {
    return withPasswordSubmitting(kernel)(Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(kernel.loading.setError(missingAccountDetailsError)));
    })(function (details) {
        return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
            return Ouroboros_Services_Clients_Interop_TaskEither.fold(handlePasswordResetError(kernel))(function (v1) {
                return handlePasswordResetRequestSuccess(kernel);
            })(runPasswordResetRequest(kernel.requestPasswordReset)({
                email: details.email
            }));
        })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(kernel.loading.setLoading)));
    })(readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(kernel.accountDetails))));
};
var onRequestPasswordReset = function (kernel) {
    return function (v) {
        return Ouroboros_Programs_Capabilities.runTaskRunner(kernel.taskRunner)(requestPasswordResetTask(kernel));
    };
};
var handlePasswordResetCompleteSuccess = function (kernel) {
    return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(kernel.passwordResetCompleted))(true));
    })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(kernel.loading.setSuccess)));
};
var handleMembershipFetchSuccess = function (kernel) {
    return function (response) {
        return function (usersResponse) {
            return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
                return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(kernel.loading.setSuccess));
            })(Ouroboros_Services_Clients_Interop_Task.fromIO(updateMembership(kernel)(response)(usersResponse)));
        };
    };
};
var handleAccountSuccess = function (kernel) {
    return function (response) {
        return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
            return Ouroboros_Services_Clients_Interop_TaskEither.fold(function (v1) {
                return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(kernel.loading.setSuccess));
            })(handleMembershipFetchSuccess(kernel)(response))(kernel.adminUserClient.listUsers);
        })(Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetSome(kernel.accountDetails))(response)));
    };
};
var handleAccountError = function (kernel) {
    return function (errorValue) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(kernel.loading.setError(toAccountErrorInput(errorValue))));
    };
};
var fetchAccountDetailsTask = function (kernel) {
    return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
        return Ouroboros_Services_Clients_Interop_TaskEither.fold(handleAccountError(kernel))(handleAccountSuccess(kernel))(kernel.accountClient.getAccountDetails);
    })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(kernel.loading.setLoading)));
};
var documentationPath = "/documentation/drafting/frontend-program-builder/controllers/account_management_controller.md";
var buildPasswordResetRequest = function (payload) {
    return {
        token: Ouroboros_Models_Brands_PasswordResetToken.makePasswordResetToken(Data_String_Common.trim(payload.token)),
        password: Ouroboros_Models_Brands_Password.makePassword(payload.password)
    };
};
var completePasswordResetTask = function (kernel) {
    return function (payload) {
        return withPasswordSubmitting(kernel)((function () {
            var $37 = Data_String_Common.trim(payload.token) === "";
            if ($37) {
                return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(kernel.loading.setError(missingResetTokenError)));
            };
            var $38 = payload.password === "" || payload.confirmPassword === "";
            if ($38) {
                return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(kernel.loading.setError(missingPasswordError)));
            };
            var $39 = payload.password !== payload.confirmPassword;
            if ($39) {
                return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(kernel.loading.setError(passwordMismatchError)));
            };
            return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
                return Ouroboros_Services_Clients_Interop_TaskEither.fold(handlePasswordResetError(kernel))(function (v1) {
                    return handlePasswordResetCompleteSuccess(kernel);
                })(runPasswordResetComplete(kernel.completePasswordReset)(buildPasswordResetRequest(payload)));
            })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(kernel.loading.setLoading)));
        })());
    };
};
var onCompletePasswordReset = function (kernel) {
    return function (payload) {
        return Ouroboros_Programs_Capabilities.runTaskRunner(kernel.taskRunner)(completePasswordResetTask(kernel)(payload));
    };
};
var buildOnInit = function (kernel) {
    return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
        return Ouroboros_Services_Clients_Interop_Option.some(Ouroboros_Programs_Capabilities.runTaskRunner(kernel.taskRunner)(fetchAccountDetailsTask(kernel)));
    })(function (v) {
        return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
    })(readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(kernel.accountDetails)));
};
export {
    buildOnInit,
    onRequestPasswordReset,
    onCompletePasswordReset,
    documentationPath
};
//# sourceMappingURL=index.js.map
